module.exports = __webpack_public_path__ + "static/feature-news-2f177211d585f3d391b14d64197fb93f.jpg";